import React, { Component } from "react";
//
//
// SVG ICON
import playButton from "../../img_icons/up-arrow-svgrepo-com_3.svg";
//
//1
const Scroll = (showBelow) => {
  //
  //2
  const handleClick = (e) => {
    e.preventDefault();
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };
  //
  //
  //
  return (
    <div className="scrollToTop__imgBox_svg">
      {/* 3 */}

      <img onClick={handleClick} className="svg" src={playButton} alt="img" />
    </div>
  );
};

//

class ScrollToTop extends Component {
  render() {
    return (
      <>
        <section id="scrollToTop">
          <Scroll />
        </section>
      </>
    );
  }
}

export default ScrollToTop;
